import React, { useState } from 'react';
import { Button, TextField, Typography } from '@material-ui/core';
import { Auth } from 'aws-amplify';
import { useHistory } from 'react-router-dom';
import { translateError } from '../../utils/messages';

const ResetPasswordPage = () => {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const history = useHistory();

  const handlePasswordReset = async () => {
    try {
      await Auth.forgotPassword(email);
      setSuccess('認証コードを送信しました。メールをご確認ください。');
      setError('');
      setStep(2);
    } catch (error) {
      setError(translateError(error.message));
      setSuccess('');
    }
  };

  const handlePasswordSubmit = async () => {
    try {
      await Auth.forgotPasswordSubmit(email, code, newPassword);
      setSuccess('パスワードが変更されました。サインインしてください。');
      setError('');
      setTimeout(() => {
        history.push('/signin');
      }, 2000);
    } catch (error) {
      setError(translateError(error.message));
      setSuccess('');
    }
  };

  const handleResendCode = async () => {
    try {
      await Auth.forgotPassword(email);
      setSuccess('認証コードを再送信しました。メールをご確認ください。');
      setError('');
    } catch (error) {
      setError(translateError(error.message));
      setSuccess('');
    }
  };  

  const handleGoBack = () => {
    history.push('/signin');
  };

  return (
    <div style={{ maxWidth: 400, margin: '0 auto', padding: 20 }}>
      <Typography variant="h5" gutterBottom>
        パスワードリセット
      </Typography>

      {step === 1 ? (
        <>
          <TextField
            label="メールアドレス"
            type="email"
            fullWidth
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            margin="normal"
          />
          <Button
            variant="contained"
            style={{
              backgroundColor: 'orange',
              color: 'white',
              marginTop: 20,
            }}
            fullWidth
            onClick={handlePasswordReset}
          >
            コードを送信
          </Button>
        </>
      ) : (
        <>
          <TextField
            label="認証コード"
            fullWidth
            value={code}
            onChange={(e) => setCode(e.target.value)}
            margin="normal"
          />
          <TextField
            label="新しいパスワード"
            type="password"
            fullWidth
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            margin="normal"
          />
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={handlePasswordSubmit}
            style={{ marginTop: 20 }}
          >
            パスワードを変更
          </Button>

          <Button
            variant="text"
            color="secondary"
            fullWidth
            onClick={handleResendCode}
            style={{ marginTop: 10 }}
          >
            認証コードを再送信
          </Button>
        </>
      )}

      {error && (
        <Typography color="error" variant="body2" style={{ marginTop: 10 }}>
          {error}
        </Typography>
      )}
      {success && (
        <Typography color="primary" variant="body2" style={{ marginTop: 10 }}>
          {success}
        </Typography>
      )}

      <Typography
        color="primary"
        style={{
          marginTop: 20,
          display: 'block',
          textAlign: 'center',
          cursor: 'pointer',
        }}
        onClick={handleGoBack}
      >
        サインインページに戻る
      </Typography>
    </div>
  );
};

export default ResetPasswordPage;

